<template>
  <div id="II">
    <el-card class="IIcard" v-if="stratege.info.content!=''">
        <div class="IItitleimg " v-html="stratege.info.content"></div>
  <!--   <img :src="serverUrl+'/' +stratege.info.img" id="IIimg" />-->
    </el-card>
    <el-card class="IIcard" v-for="(items, i) in stratege.info.params" :key="i">
      
      <div class="IItitle"></div>
      <ul>
        <li v-for="(item, i) in items" :key="i">
          {{ item }}
        </li>
      </ul>
    </el-card>
    <el-card class="IIcard">
      <div class="IItitle" v-html="stratege.info.warning"></div>
      
    </el-card>
  </div>
</template>

<script>
import { defineComponent, reactive } from "vue";
import { useMyStorage } from "@/store/global";
export default defineComponent({
  props: {
    ids: {
      type: Number,
      requred: true,
    },
  },
  name: "StrategeInfo",
  setup(props) {
    const store = useMyStorage();
    const id=props.ids%100
    const group=(props.ids-id)/100-1
    console.log(group)
    console.log(id)
    const stratege = reactive(store.strateges[group].blockItems[id]);
    const serverUrl=store.ServerUrl;
    return { stratege, serverUrl };
  },
});
</script>
<style lang="scss">
#II {
  #IIimg {
    width: 100%;
  }
  .LLIprogram {
    .LLIprogramcard {
      width: 45%;
      margin: 2%;
      display: inline-block;
      height: 140px;
    }
  }
  .IIcard {
    width: 100%;
    margin-bottom: 15px;
    .IItitleimg{
      font-size: 22px;
      font-style: normal;
      font-weight: 500;
      line-height: 28px;
      letter-spacing: 0em;
      text-align: left;
      color: #222;
      margin-bottom: 15px;
      padding: 5px 30px;
    }
    .IItitle {
      //   font-family: Montserrat;
      font-size: 24px;
      font-style: normal;
      font-weight: 500;
      line-height: 22px;
      letter-spacing: 0em;
      text-align: left;
      color: #222;
      margin-bottom: 15px;
    }
    li {
      list-style-image: url(~@/assets/images/arrow-right.svg);
      font-size: 20px;
      margin-bottom: 5px;
    }
  }

  .LLIgoals {
    margin-left: 40px;
    margin-bottom: 30px;
    .LLIgoalcard {
      display: inline-block;
      width: 250px;
      height: 250px;
      margin: 10px;
    }
  }
}
</style>
